// extracted by mini-css-extract-plugin
export default {"commentContainer":"Comment_commentContainer__ZQxtE","author":"Comment_author__t6KgZ","comment":"Comment_comment__ojaPP"};